import {Favorite} from "./Favorite";
import {OpeningHours} from "./OpeningHours";
import axios from "axios";

export class LocationDetail {
    constructor(el) {
        this.el = el;
        this.data = null;
        this.favorite = new Favorite(this);
        this.openingHours = new OpeningHours(this);
    }

    getClassName(className, modifier) {
        if (modifier) return `location-detail__${className}--${modifier}`;
        return `location-detail__${className}`;
    }

    find(elementName) {
        return this.el.querySelectorAll(`.${this.getClassName(elementName)}`);
    }

    findOne(elementName) {
        return this.el.querySelector(`.${this.getClassName(elementName)}`);
    }

    getData() {
        if(!this.data) {
            return axios.get(`/.rest/personalized/v1/locations/${this.getConfig().locationId}`)
                .then(response => {
                    this.data = response.data;
                    return this.data;
                });
        }
        return Promise.resolve(this.data);
    }

    getConfig() {
        if (!this.config) {
            try {
                const json = this.findOne('config-data').innerHTML;

                this.config = JSON.parse(json);
            } catch(e) {
                return {
                    locationId: '',
                    isOpen: false
                }
            }

        }

        return this.config;
    }
}

export const init = () => document
    .querySelectorAll('.location-detail')
    .forEach(detailComponent => new LocationDetail(detailComponent));

